export default "__VITE_ASSET__Bxi7OcyP__"